import React from "react";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import { Info } from "react-feather";
import ic_phone_call_green from "../../../assets/ic_phone_call_green.svg"
import ic_phone_call_red from "../../../assets/ic_phone_call_red.svg"

export default function ServiceRequest(props) {
	return (
		<div className="col-md-12">
			{props.requests.map((request, i) => {
				let callButtonColor = "red";
				if (request["dtLastHandled"]) {
					callButtonColor = "green";
			}
				// const currentDate = new Date();

				// if (request["dtLastHandled"]) {
				// 	const dtLastHandledDate = new Date(request["dtLastHandled"]);
				// 	if (
				// 		currentDate.getUTCFullYear() === dtLastHandledDate.getUTCFullYear() &&
				// 		currentDate.getUTCMonth() === dtLastHandledDate.getUTCMonth() &&
				// 		currentDate.getUTCDate() === dtLastHandledDate.getUTCDate()
				// 	) {
				// 		callButtonColor = "green";
				// 		console.log("Matched", )
				// 	} else {
				// 		callButtonColor = "red";
				// 		console.log("Not Matched")
				// 	}
				// } else {
				// 	callButtonColor = "red";
				// isCouponApplied =rowInfo.original.sCouponCode === "JPMCCOMPLAINCEGST100" && rowInfo.original.fDiscountAmount === rowInfo.original.fAmountFull
				// }
				return (
					<div className={`my-services-card ${ request.sCouponCode === "JPMCCOMPLAINCEGST100" && request.fDiscountAmount === request.fAmountFull? "pink-bg": request.sServiceCode === "GRPEXPRTCONSULT" ? "light-blue-bg" : ""}`}>
						<ServiceRequestHeader
							customer={props.customer}
							onUserProfileClick={props.onUserProfileClick}
						// serviceRequest={props.requests[0]}
						/>
						<div className={`row conv-pl15 conv-pr15 conv-pt20 conv-pb30`}>
							<ServiceRequestBody
								callButtonColor={callButtonColor}
								request={request}
								index={i}
								key={i}
								onServiceRequestClick={
									props.onServiceRequestClick
								}
								serviceRequestList={props.serviceRequestList}
								handleClickPackage={props.handleClickPackage}
							/>
							{props.requests.map((request, i) => {
								let callButtonColor = "red";
								if (request["dtLastHandled"]) {
									callButtonColor = "green";
								}

							})}
						</div>
					</div>
				);
			})}
			{/* <div className="my-services-card">
				<ServiceRequestHeader
					customer={props.customer}
					onUserProfileClick={props.onUserProfileClick}
					// serviceRequest={props.requests[0]}
				/>
				<div className={`row conv-pl15 conv-pr15 conv-pt20 conv-pb30 ${props.requests[0].nPackageInstanceId ? "light-blue-bg" : ""}`}>
					{props.requests.map((request, i) => {
						let callButtonColor = "red";
						if (request["dtLastHandled"]) {
							callButtonColor = "green";
						}
						return (
							<ServiceRequestBody
								callButtonColor={callButtonColor}
								request={request}
								index={i}
								key={i}
								onServiceRequestClick={
									props.onServiceRequestClick
								}
							/>
						);
					})}
				</div>
			</div> */}
		</div>
	);
}

function ServiceRequestHeader({
	customer,
	onUserProfileClick,
	serviceRequest,
	...props
}) {
	return (
		<div className="my-services-card-header service-request flex align-items-center">
			<div>{customer.email}</div>
		</div>
	);
}

function ServiceRequestBody({ request, ...props }) {
	const getServiceName = (code) => {
		if (!code) return;
		const found = find(getServiceTypesMaster(), { sServiceCode: code });
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	const serviceCost = (request) => {
		if (!request) return;

		let fPackageOfferAmount = "0";
		let fdeAsraPlatformCharges = "0";
		let fPackageOfferGST = "0";
		if (request.fPackageOfferAmount) {
			fPackageOfferAmount = request.fPackageOfferAmount.toString();
		}
		if (request.fPackageOfferGST) {
			fPackageOfferGST = request.fPackageOfferGST.toString();
		}
		if (request.fdeAsraPlatformCharges) {
			fdeAsraPlatformCharges = request.fdeAsraPlatformCharges.toString();
		}
		return "Pkg Service Cost With GST:" + fPackageOfferAmount.toString() + "\n" + "deAsra Platform Charges:" + fdeAsraPlatformCharges.toString() + "\n" + "GST On Platform Charges:" + fPackageOfferGST.toString();
	};

	const getCouponExpiryDate = (request) => {
		return "Coupon Expiry Date: " + moment(request.dtCouponExpiryDate).format("lll");
	};

	/*return (
		<li
			className={`list-group-item cursor-pointer ${request.nPackageInstanceId ? "light-blue-bg" : ""}`}
			onClick={() => props.onServiceRequestClick(request)}
		>
			<div className="flex">
				<div>
					<PhoneCall color={props.callButtonColor} />
				</div>
				<div className="ml-2 flex-fill">
					<div>{getServiceName(request.sServiceCode)} ({request.sServiceDisplayName})</div>
					<div>
						<small className="ml-0">
						Package/Offering Title:{" "}
							{request.sPackageOfferTitle ?<span><b>{request.sPackageOfferTitle}</b></span> :<i>Not Available</i>}
						</small>
					</div>
					<div>
						<small className="ml-0">
						Package/Offering Instance ID:{" "}
							{request.nPackageInstanceId ?<span><b>{request.nPackageInstanceId}</b></span> :<i>Not Available</i>}
						</small>
					</div>
					<div>
						<small className="ml-0">
						Total Service Cost In Pkg:{" "}
							{request.fPackageOfferTotalServiceCharge ? 
							<>
								<span>
									<b>{request.fPackageOfferTotalServiceCharge}</b> (Incl. GST)
								</span>
								<span title={serviceCost(request)}
								>
								<Info style={{marginLeft:"10px",width:"15px"}}/>
								</span>
								
								
							</>
								:
								<i>Not Available</i>}
						</small>
					</div>
					<div>
						<small className="ml-0">
							Name:{" "}
							{request.sFirstName || request.sLastName ? <span>{request.sFirstName}&nbsp;{request.sLastName}</span> :
								<i>Not Available</i>}

						</small>
					</div>
					<div>
						<small className="ml-0">
							Phone number:{" "}
							{request.sContactNumber || (
								<i>Not Available</i>
							)}
						</small>
					</div>
					<div>
						<small className="ml-0">
							Sector:{" "}
							{request.business_sector_name || (
								<i>Not Available</i>
							)}
						</small>
					</div>
					<div>
						<small className="ml-0">
							Service Request ID : {request.nResourceInstanceId}
						</small>
					</div>
					<div>
						<small className="ml-0">
							FollowUp Date:{" "}
							{moment(request.dtFollowupOn).format("lll") || (
								<small>
									<i>Not Available.</i>
								</small>
							)}
						</small>
						<br></br>
						<small className="ml-0">
							Requested Date:{" "}
							{moment(request.dtRequested).format("lll") || (
								<small>
									<i>Not Available.</i>
								</small>
							)}
						</small>
						<br></br>
						<small>
							Payment Link Status:{" "}
							{(request.sPaymentStatus &&
								(request.sPaymentStatus === "Credit"
									? "Payment Received"
									: request.sPaymentStatus === "Failed"
									? "Payment Failed"
									: "Payment Link Deactivated")) ||
								(request.urlPayment ? (
									<small>
										<i>Payment Pending</i>
									</small>
								) : (
									<small>
										<i>Not Sent</i>
									</small>
								))}
						</small>
						<br></br>
						<small>
							Status:{" "}
							{request.refSRState || (
								<small>
									<i>Status Unavailable.</i>
								</small>
							)}
						</small>
						<br></br>
						<small>
							Device Type:{" "}
							{request.sDeviceType ? (
								<>{request.sDeviceType}</>
							):(<small>
								<i>Not Available</i>
							</small>)}
						</small>
						<br></br>
					</div>
					<div>
						<small className="ml-0">
							Pincode:{" "}
							{request.sBusinessPincode || (
								<small>
								<i>Not Available</i>
							</small>
							)}
						</small>
						<br></br>
						<small className="ml-0">
							City:{" "}
							{request.sBusinessCity || (
								<small>
								<i>Not Available</i>
							</small>
							)}
						</small>
						<br></br>
						<small className="ml-0">
							State:{" "}
							{request.sBusinessState || (
								<small>
								<i>Not Available</i>
							</small>
							)}
						</small>
						<br></br>
						<small className="ml-0">
							Stay Engaged with EHH:{" "}
							{request.bStayEngagedWithEhh ? "Yes" : "No"}
						</small>
						<br></br>
						<small>
						Requested Call Back:{" "}
							{request.bRequestedCallBack ? (
								<>{"Yes"}</>
							):(<small>
								<i>NA</i>
							</small>)}
						</small>
						<br></br>
						<small>
						External Service Partner:{" "}
							{request.refExternalServicePartner ? (
								<>{request.refExternalServicePartner}
								{request.ext_sp_org? (" ("+request.ext_sp_org+")"): ""}
								</>
							):(<small>
								<i>NA</i>
							</small>)}
						</small>
						<br></br>
						<small>
							Coupon Applied:{" "}{request.bCouponApplied ? 
							(
								<>
									{request.dtCouponExpiryDate?
									(
										<>
											{
												new Date(request.dtCouponExpiryDate)<new Date()?
												(
													<>
														<span style={{color:"red"}}>Yes</span>
														<span title={getCouponExpiryDate(request)}>
														<Info style={{marginLeft:"10px",width:"15px"}}/>
														</span>
													</>
												):
												(
													<>
														<span style={{color:"green"}}>Yes</span>
														<span title={getCouponExpiryDate(request)}>
														<Info style={{marginLeft:"10px",width:"15px"}}/>
														</span>
													</>													
												)
											}
										</>
									):
									(
										<>
											<span>
												Yes
												<span title={"Coupon Expiry Date: Not Available"}>
												<Info style={{marginLeft:"10px",width:"15px"}}/>
												</span>
											</span>
										</>
									)}
								</>
							):
							(
								<small><i>No</i></small>
							)}
						</small>
						<br></br>
						<small>
							Coupon Code:{" "}{request.sCouponCode ? 
							(
								<>
									{request.dtCouponExpiryDate?
									(
										<>
											{
												new Date(request.dtCouponExpiryDate)<new Date()?
												(<span style={{color:"red"}}>{request.sCouponCode}</span>):
												(<span style={{color:"green"}}>{request.sCouponCode}</span>)
											}
										</>
									):
									(
										<span>{request.sCouponCode}</span>
									)}
								</>
							):
							(
								<small><i>NA</i></small>
							)}
						</small>
						<br></br>
						<small>
							Coupon Discount Amount:{" "}{request.fDiscountAmount ? 
							(
								<>
									{request.dtCouponExpiryDate?
									(
										<>
											{
												new Date(request.dtCouponExpiryDate)<new Date()?
												(<span style={{color:"red"}}>{request.fDiscountAmount}</span>):
												(<span style={{color:"green"}}>{request.fDiscountAmount}</span>)
											}
										</>
									):
									(
										<span>{request.fDiscountAmount}</span>
									)}									
								</>
							):
							(
								<small><i>NA</i></small>
							)}
						</small>
						<br></br>
						<small>
							Service Cost After Discount:{" "}{request.fDiscountAmount ? 
							(
								<>
									{request.dtCouponExpiryDate?
									(
										<>
											{
												new Date(request.dtCouponExpiryDate)<new Date()?
												(<span style={{color:"red"}}>{request.fAmountFirst-request.fDiscountAmount}</span>):
												(<span style={{color:"green"}}>{request.fAmountFirst-request.fDiscountAmount}</span>)
											}
										</>
									):
									(
										<span>{request.fAmountFirst-request.fDiscountAmount}</span>
									)}
									
								</>
							):
							(
								<small><i>NA</i></small>
							)}
						</small>
					</div>
					<br></br>
					<div className="flex justify-content-between">
						<div>
							{request.refSRState === "Cancelled" ? (
								<div>
									<small>
										Reason for Cancellation:{" "}
										{request.sSRCancellationReason ===
										"Other" ? (
											<small>
												{request.sSRCancellationReason}
												{"-"}
												{
													request.sSRCancellationReasonOtherDescription
												}
											</small>
										) : (
											<small>
												{request.sSRCancellationReason}
											</small>
										)}
									</small>
								</div>
							) : (
								""
							)}
						</div>
						<br></br>
						
						<div>
							<ArrowRight color="purple" />
						</div>
					</div>
				</div>
			</div>
		</li>
	);*/
	return (
		<>
			{/* {
				parseInt(props.index)>0?
				(
					<div className="divider conv-mt30 conv-mb25"></div>
				)
				:("")
			}			 */}
			<div className="col-12">
				<img
					alt=""
					src={props.callButtonColor === "red" ? ic_phone_call_red : ic_phone_call_green}
					height={"25px"}
					width={"25px"}
					className="conv-mr15 conv-float-left"
				/>
				<span className="my-services-card-service-title">{getServiceName(request.sServiceCode)}
					{/* {
						request.nPackageInstanceId ? <>({request.sPackageOfferTitle})</> : ""
					} */}
					{
						request.nPackageInstanceId ? (
							<>({request.sPackageOfferTitle})</>
						) : (
							(request.sServiceCode === "MKTLINKAGEEXHIBITION" ||
							request.sServiceCode === "MKTLINKAGEBULKBUYER" ||
							request.sServiceCode === "MKTLINKAGECORPLINKAGE" ||
							request.sServiceCode === "MKTLINKAGEEXPORT" ||
							request.sServiceCode === "MKTLINKAGEECOM" ||
							request.sServiceCode === "MKTLINKAGESHOPINSHOP") && (
							<>({request.sServiceDisplayName})</>
							)
						) || ""
						}
					{/* ({request.sServiceDisplayName}) */}

				</span>
			</div>

			<div className="col-12 conv-mt20">
				<div className="conv-width-140px my-services-key conv-float-left">Instance ID :</div>
				<div className="my-services-value">{request.nResourceInstanceId}</div>
			</div>

			<div className="col-12 conv-mt10">
				<div className="conv-width-140px my-services-key conv-float-left">Customer No. :</div>
				<div className="my-services-value">{request.sContactNumber || "Not Available"}</div>
			</div>

			<div className="col-12 conv-mt10">
				<div className="conv-width-140px my-services-key conv-float-left">Status :</div>
				<div className="my-services-value">{request.refSRState || "Status Unavailable"}</div>
			</div>

			<div className="col-12 conv-mt10">
				<div className="conv-width-140px my-services-key conv-float-left">Ext. SP :</div>
				<div className="my-services-value">
					{
						request.refExternalServicePartner ?
							(
								<>
									{request.refExternalServicePartner}
									{request.ext_sp_org ? (" (" + request.ext_sp_org + ")") : ""}
								</>
							) : ("NA")}
				</div>
			</div>

			<div className="col-12 conv-mt10">
				<div className="conv-width-140px my-services-key conv-float-left">Follow-up date :</div>
				<div className="my-services-value">{moment(request.dtFollowupOn).format("lll") || "Not Available"}</div>
			</div>

			<div className="col-12 conv-mt30 conv-text-center">
				<button className="lpm-con-btn-filled conv-pl15 conv-pr15 conv-font14"
					onClick={(e) => {
						// props.onServiceRequestClick(request.nResourceInstanceId)
						if(request.nPackageInstanceId){
							props.onServiceRequestClick(request.nResourceInstanceId)

							// Filter items with same nPackageInstanceId
							const allRequests = Object.values(props.serviceRequestList || {}).flat();
							const check = allRequests.filter(
								(item) => item?.nPackageInstanceId === request?.nPackageInstanceId
							);
							// console.log("check:::::", check);
							if(check && check.length>0 && check[0]?.sPackageOfferTitle !== 'Long Term Engagement Package'){
								props.handleClickPackage(check)
							}else{
								const selectedService = allRequests.filter(
								(item) => item?.nResourceInstanceId === request.nResourceInstanceId
							);
								props.handleClickPackage(selectedService)
							}

						}else{
						props.onServiceRequestClick(request.nResourceInstanceId)
						}
					}}>
					View Details +
				</button>
			</div>
		</>
	);
}
